// Mock data untuk Gudang Boss Ijan
// Katalog Produk Baharu

export const mockProducts = [
  {
    id: -32,
    name: "SET SOFA VERSACE EMAS 3+2+1+1 - BALDU KELABU BERKANCING + MEJA",
    originalPrice: 4400,
    salePrice: 2200,
    discount: 50,
    bestSeller: true,
    limitedEdition: true,
    stock: 1,
    description: "Set Sofa Versace dengan bingkai emas dan baldu kelabu berkancing kristal. Ukiran Versace Greek klasik. Set lengkap 3+2+1+1 dengan meja kopi emas.",
    features: [
      "1x Sofa 3 Seater",
      "1x Sofa 2 Seater",
      "2x Single Seater",
      "1x Meja Kopi Emas",
      "Baldu Kelabu Berkancing",
      "Ukiran Versace Greek",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/8annas16_7031.jpg"
    ],
    category: "sofa"
  },
  {
    id: -33,
    name: "SET SOFA JATI KLASIK 3+2+1+1 - DAMASK EMAS BERKANCING + MEJA",
    originalPrice: 3600,
    salePrice: 1800,
    discount: 50,
    bestSeller: true,
    topSelling: true,
    stock: 2,
    description: "Set Sofa Jati Klasik dengan kusyen damask emas berkancing kristal. Ukiran bunga halus di bingkai. Set lengkap 3+2+1+1 dengan meja kopi jati.",
    features: [
      "1x Sofa 3 Seater",
      "1x Sofa 2 Seater",
      "2x Single Seater",
      "1x Meja Kopi Jati",
      "Damask Emas Berkancing",
      "Ukiran Bunga Klasik",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/mm6vj14j_7025.jpg"
    ],
    category: "sofa"
  },
  {
    id: -34,
    name: "SET SOFA JATI UKIRAN BUNGA 3+2+1+1 - DAMASK KELABU + MEJA",
    originalPrice: 4000,
    salePrice: 2000,
    discount: 50,
    bestSeller: true,
    stock: 2,
    description: "Set Sofa Jati dengan ukiran bunga di lengan dan bingkai. Kusyen damask kelabu berkancing kristal. Set lengkap 3+2+1+1 dengan meja kopi ukiran.",
    features: [
      "1x Sofa 3 Seater",
      "1x Sofa 2 Seater",
      "2x Single Seater",
      "1x Meja Kopi Ukiran",
      "Damask Kelabu Berkancing",
      "Ukiran Bunga Jepara",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/8krofpsw_7028.jpg"
    ],
    category: "sofa"
  },
  {
    id: -31,
    name: "SET SOFA JATI UKIRAN DIRAJA 3+2+1+1 - BALDU COKLAT DAMASK + MEJA",
    originalPrice: 5200,
    salePrice: 2600,
    discount: 50,
    bestSeller: true,
    limitedEdition: true,
    stock: 2,
    description: "Set Sofa Jati Ukiran Diraja dengan baldu coklat damask berkancing kristal. Ukiran mahkota dan bunga sangat detail. Set lengkap 3+2+1+1 dengan 2 meja kopi ukiran.",
    features: [
      "1x Sofa 3 Seater",
      "1x Sofa 2 Seater",
      "2x Single Seater",
      "2x Meja Kopi Ukiran",
      "Baldu Coklat Damask",
      "Ukiran Mahkota Diraja",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/bczqozlr_5780.png"
    ],
    category: "sofa"
  },
  {
    id: -27,
    name: "SET MEJA MAKAN MINIMALIST JATI 6 KERUSI - KUSYEN KELABU MODEN",
    originalPrice: 3000,
    salePrice: 1500,
    discount: 50,
    bestSeller: true,
    topSelling: true,
    stock: 3,
    description: "Set Meja Makan Minimalist Jati dengan 6 kerusi berkusyen kelabu moden. Reka bentuk Scandinavian dengan kaki meja unik. Sesuai untuk ruang makan kontemporari.",
    features: [
      "Meja Jati Solid",
      "6 Kerusi Kusyen Kelabu",
      "Reka Bentuk Scandinavian",
      "Kaki Meja Unik",
      "Finishing Kilat Premium",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/mc74pi4k_5107.jpg"
    ],
    category: "meja-makan"
  },
  {
    id: -28,
    name: "KABINET TV JATI ROTAN MINIMALIST - GAYA BOHEMIAN",
    originalPrice: 1600,
    salePrice: 800,
    discount: 50,
    bestSeller: true,
    stock: 4,
    description: "Kabinet TV Jati dengan pintu rotan anyaman tangan. Reka bentuk bulat minimalist gaya Bohemian. 2 laci dan ruang simpanan. Sesuai untuk TV 50-65 inci.",
    features: [
      "Pintu Rotan Anyaman Tangan",
      "2 Laci Tengah",
      "Ruang Simpanan Luas",
      "Gaya Bohemian Minimalist",
      "Kayu Jati Solid",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/inkju24w_5118.png",
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/2v4go6mi_5117.png"
    ],
    category: "kabinet-tv"
  },
  {
    id: -29,
    name: "SET MEJA MAKAN MINIMALIST JATI 4 KERUSI - WALNUT GELAP",
    originalPrice: 2400,
    salePrice: 1200,
    discount: 50,
    bestSeller: true,
    stock: 3,
    description: "Set Meja Makan Minimalist Jati finishing Walnut gelap dengan 4 kerusi berkusyen cream. Reka bentuk ringkas dan elegan untuk ruang makan moden.",
    features: [
      "Meja Jati Finishing Walnut",
      "4 Kerusi Kusyen Cream",
      "Reka Bentuk Minimalist",
      "Warna Gelap Elegan",
      "Kayu Jati Solid",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/29tkc01i_5110.jpg"
    ],
    category: "meja-makan"
  },
  {
    id: -30,
    name: "SET MEJA MAKAN MINIMALIST JATI 4 KERUSI ROTAN - SCANDINAVIAN",
    originalPrice: 2400,
    salePrice: 1200,
    discount: 50,
    bestSeller: true,
    stock: 3,
    description: "Set Meja Makan Minimalist Jati dengan 4 kerusi rotan berkusyen cream. Kombinasi kayu jati dan rotan untuk gaya Scandinavian yang hangat dan natural.",
    features: [
      "Meja Jati Solid",
      "4 Kerusi Rotan + Kusyen",
      "Gaya Scandinavian",
      "Kombinasi Jati & Rotan",
      "Finishing Natural",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/ky0w9q5v_5119.png"
    ],
    category: "meja-makan"
  },
  {
    id: -26,
    name: "ALMARI JAM GRANDFATHER UKIRAN PUTIH EMAS - GAYA ISTANA",
    originalPrice: 3000,
    salePrice: 1500,
    discount: 50,
    bestSeller: true,
    limitedEdition: true,
    stock: 1,
    description: "Almari Jam Grandfather dengan ukiran putih dan emas mewah. Jam pendulum klasik di tengah. 2 pintu kaca display dengan rak kaca. Laci bawah untuk simpanan. Gaya istana Eropah yang sangat eksklusif.",
    features: [
      "Jam Pendulum Klasik",
      "2 Pintu Kaca Display",
      "Rak Kaca Premium",
      "3 Laci Simpanan Bawah",
      "Ukiran Putih & Emas",
      "Gaya Istana Eropah",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/6fsjbgcs_3025.png"
    ],
    category: "almari"
  },
  {
    id: -25,
    name: "SET SOFA JATI FULL SET BERKERAWANG 3+2+1+1 - SIAP MEJA KOPI & KACA",
    originalPrice: 6600,
    salePrice: 3299,
    discount: 50,
    bestSeller: true,
    limitedEdition: true,
    stock: 2,
    description: "Set Sofa Jati Full Set dengan ukiran berkerawang sangat detail. Kusyen jacquard premium berkancing. Set lengkap 3+2+1+1 dengan meja kopi berkerawang dan kaca.",
    features: [
      "1x Sofa 3 Seater",
      "1x Sofa 2 Seater",
      "2x Single Seater",
      "1x Meja Kopi Berkerawang + Kaca",
      "Ukiran Nenas Mahkota",
      "Kusyen Jacquard Premium",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/rumehwvb_3004.jpg",
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/mnxcru0r_3011.jpg",
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/h7uy8xn3_3014.jpg",
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/sh6l3f04_3017.jpg"
    ],
    category: "sofa"
  },
  {
    id: -24,
    name: "SET MEJA MAKAN 8 KERUSI BERKUSYEN CREAM - GRADE A + FREE KARPET DUBAI",
    originalPrice: 6000,
    salePrice: 3000,
    discount: 50,
    bestSeller: true,
    limitedEdition: true,
    stock: 2,
    description: "Set Meja Makan Jati Oval Premium dengan 8 kerusi berkusyen kulit cream berkancing kristal. Ukiran mahkota klasik pada kerusi. Kaki meja ukiran bunga. PERCUMA Karpet Dubai Besar!",
    features: [
      "Meja Oval Ukiran Klasik",
      "8 Kerusi Berkusyen Cream",
      "Berkancing Kristal Premium",
      "Finishing Grade A",
      "Kaki Meja Ukiran Bunga",
      "FREE Karpet Dubai Besar",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/9b00xx09_2613.jpg",
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/hruz9po8_2616.jpg",
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/q1iokdf7_2619.jpg",
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/c97ataqp_2622.jpg",
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/2dfbajig_2625.jpg"
    ],
    category: "meja-makan"
  },
  {
    id: -23,
    name: "SET MEJA MAKAN 10 KERUSI BERKUSYEN FINISHING KILAT - GRADE A",
    originalPrice: 6000,
    salePrice: 3000,
    discount: 50,
    bestSeller: true,
    limitedEdition: true,
    stock: 2,
    description: "Set Meja Makan Jati Premium dengan 10 kerusi berkusyen kulit berkancing kristal. Ukiran bulatan klasik di atas meja. Finishing kilat Grade A yang sangat mewah.",
    features: [
      "Meja Ukiran Bulatan Klasik",
      "10 Kerusi Berkusyen Kulit",
      "Berkancing Kristal Premium",
      "Finishing Kilat Grade A",
      "Kayu Jati Solid Premium",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/sheb2jn2_2602.jpg",
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/9tix3764_2605.jpg",
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/1r49gou9_2608.jpg"
    ],
    category: "meja-makan"
  },
  {
    id: -22,
    name: "SET SOFA JATI BALDU NAVY 3+2+1+1 + MEJA - UKIRAN VERSACE",
    originalPrice: 1800,
    salePrice: 900,
    discount: 50,
    bestSeller: true,
    topSelling: true,
    stock: 4,
    description: "Set Sofa Jati dengan baldu navy blue berkancing dan ukiran Versace klasik. Set lengkap 3+2+1+1 dengan meja kopi. Gaya mewah untuk ruang tamu.",
    features: [
      "1x Sofa 3 Seater",
      "1x Sofa 2 Seater",
      "2x Single Seater",
      "1x Meja Kopi Ukiran",
      "Baldu Navy Blue Berkancing",
      "Ukiran Versace Klasik",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/7qjdqssy_1940.png"
    ],
    category: "sofa"
  },
  {
    id: -21,
    name: "SET SOFA JATI FULL SET 3+2+1 + MEJA KOPI - FREE KARPET DUBAI",
    originalPrice: 4000,
    salePrice: 2000,
    discount: 50,
    bestSeller: true,
    topSelling: true,
    limitedEdition: true,
    stock: 3,
    description: "Set Sofa Jati Full Set dengan kusyen kulit merah maroon berkancing kristal. Ukiran klasik Jepara. Termasuk meja kopi besar & kecil. PERCUMA Karpet Dubai Besar!",
    features: [
      "1x Sofa 3 Seater",
      "1x Sofa 2 Seater",
      "1x Single Seater",
      "1x Meja Kopi Besar Ukiran",
      "1x Meja Kopi Kecil",
      "FREE Karpet Dubai Besar",
      "Kusyen Kulit Premium",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/9sf36xk0_891.jpg",
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/6q54psi5_894.jpg",
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/8cxntrn2_899.jpg",
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/fpxo3eow_902.jpg",
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/wkp4ax3x_905.jpg",
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/5t7bmf97_Screenshot_20260327_231819_TikTok.jpg",
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/l29mpnvm_911.jpg",
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/wftwzb6i_914.jpg"
    ],
    category: "sofa"
  },
  {
    id: -20,
    name: "SET SOFA JATI VERSACE 3+2+1 + MEJA KOPI KACA - KUSYEN BALDU CREAM",
    originalPrice: 1800,
    salePrice: 900,
    discount: 50,
    bestSeller: true,
    topSelling: true,
    stock: 3,
    description: "Set Sofa Jati dengan ukiran Versace klasik dan kusyen baldu cream berkancing. Meja kopi kaca premium. Gaya mewah untuk ruang tamu.",
    features: [
      "1x Sofa 3 Seater",
      "1x Sofa 2 Seater", 
      "1x Single Seater",
      "1x Meja Kopi Kaca",
      "Ukiran Versace Klasik",
      "Kusyen Baldu Berkancing",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/dasvebvy_666.png"
    ],
    category: "sofa"
  },
  {
    id: -1,
    name: "CLEARANCE RAYA - SET SOFA JATI BALDU MERAH 3+2+1+1 + MEJA - FREE KUSYEN BARU",
    originalPrice: 1500,
    salePrice: 500,
    discount: 67,
    clearanceSale: true,
    stock: 5,
    description: "Set Sofa Jati dengan kusyen baldu merah mewah dan ukiran halus. Set lengkap 3+2+1+1.",
    features: [
      "FREE KUSYEN BARU",
      "Sofa 3 Seater",
      "Sofa 2 Seater",
      "Sofa 1 Seater x2",
      "Meja Sisi",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/utr0o143_662.png"
    ],
    category: "sofa"
  },
  {
    id: -19,
    name: "MEJA MAKAN EMAS UKIRAN DIRAJA 8 KERUSI - GAYA ISTANA",
    originalPrice: 4000,
    salePrice: 1999,
    discount: 50,
    bestSeller: true,
    limitedEdition: true,
    stock: 2,
    description: "Meja Makan Emas Ukiran Diraja dengan 8 kerusi baldu emas berkancing kristal. Ukiran bunga penuh di atas meja. Gaya istana mewah untuk ruang makan eksklusif.",
    features: [
      "Meja Ukiran Bunga Penuh",
      "8 Kerusi Baldu Emas",
      "Berkancing Kristal Premium",
      "Gaya Istana Diraja",
      "Ukiran Emas Mewah",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/yq8quk25_D1E05BA6-5CB3-48BA-BD3D-56DA6FF271D6.png",
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/0vbov87p_552.png"
    ],
    category: "meja-makan"
  },
  {
    id: -18,
    name: "MEJA MAKAN GENDONG JATI 6 KERUSI - FINISHING KILAT GRED A",
    originalPrice: 4000,
    salePrice: 2000,
    discount: 50,
    bestSeller: true,
    topSelling: true,
    stock: 3,
    description: "Meja Makan Gendong Jati dengan 6 kerusi ukiran klasik. Finishing Kilat Gred A dengan kusyen empuk premium. Meja oval dengan ukiran bunga di atas.",
    features: [
      "Meja Oval Ukiran Bunga",
      "6 Kerusi Kusyen Empuk",
      "Finishing Kilat Gred A",
      "Kayu Jati Solid",
      "Kaki Gendong Berukir",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/g4ro1qwb_10DD889A-3E36-4663-A0DE-4C2A24A9A5FC.png"
    ],
    category: "meja-makan"
  },
  {
    id: -17,
    name: "ALMARI MAWAR FULL JATI 4 PINTU - PUTIH EMAS",
    originalPrice: 2000,
    salePrice: 1000,
    discount: 50,
    bestSeller: true,
    stock: 3,
    description: "Almari Mawar Full Jati dengan ukiran bunga mawar emas. 4 pintu besar untuk simpanan luas. Warna putih elegan sesuai untuk bilik tidur moden.",
    features: [
      "4 Pintu Besar",
      "Ukiran Bunga Mawar Emas",
      "Kayu Jati Solid",
      "Warna Putih Elegan",
      "Ruang Simpanan Luas",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/62hh1x9t_41D4B503-B1E5-4BAA-8448-CCFA392AAF14.png"
    ],
    category: "bilik-tidur"
  },
  {
    id: -16,
    name: "SET MEJA MAKAN MINIMALIST JATI 6 KERUSI - MARBLE TOP",
    originalPrice: 2200,
    salePrice: 1100,
    discount: 50,
    bestSeller: true,
    topSelling: true,
    stock: 4,
    description: "Set Meja Makan Minimalist Jati dengan top marble premium dan 6 kerusi kusyen cream. Reka bentuk moden dan elegan untuk ruang makan kontemporari.",
    features: [
      "Meja Top Marble Premium",
      "6 Kerusi Kusyen Cream",
      "Reka Bentuk Minimalist",
      "Kayu Jati Solid",
      "Sesuai Ruang Makan Moden",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/ep0adfoj_73BFBE4A-0E0A-41CE-A733-E65709034158.png"
    ],
    category: "meja-makan"
  },
  {
    id: -15,
    name: "ALMARI KACA JATI UKIRAN KLASIK 4 PINTU",
    originalPrice: 2600,
    salePrice: 1300,
    discount: 50,
    limitedEdition: true,
    stock: 2,
    description: "Almari Kaca Jati dengan ukiran klasik Jepara yang sangat detail. 4 pintu kaca untuk display dan 4 pintu bawah untuk simpanan. Mahkota ukiran bunga di atas.",
    features: [
      "4 Pintu Kaca Display",
      "4 Pintu Bawah Simpanan",
      "Ukiran Klasik Jepara",
      "Mahkota Ukiran Bunga",
      "Kayu Jati Solid Premium",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/ap8c38ts_IMG_1622.jpeg"
    ],
    category: "almari"
  },
  {
    id: -14,
    name: "ALMARI KACA JATI UKIRAN EMAS MEWAH - GAYA DIRAJA",
    originalPrice: 2400,
    salePrice: 1200,
    discount: 50,
    limitedEdition: true,
    stock: 2,
    description: "Almari Kaca Jati Ukiran Emas gaya diraja dengan detail ukiran yang sangat mewah. 4 pintu kaca dengan ukiran rantai emas dan mahkota di atas.",
    features: [
      "4 Pintu Kaca Display",
      "Ukiran Emas Mewah",
      "Gaya Diraja Eksklusif",
      "Mahkota Ukiran Premium",
      "Kayu Jati Solid",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/r0c2xe60_IMG_1623.jpeg"
    ],
    category: "almari"
  },
  {
    id: -13,
    name: "MEJA SOLEK EMAS UKIRAN + CERMIN & STOOL - GAYA VICTORIA",
    originalPrice: 1700,
    salePrice: 850,
    discount: 50,
    bestSeller: true,
    stock: 5,
    description: "Meja Solek Emas gaya Victoria dengan cermin ukiran cantik dan stool baldu. 4 laci simpanan dan ukiran daun klasik. Sesuai untuk bilik tidur mewah.",
    features: [
      "Cermin Ukiran Klasik",
      "Stool Baldu Premium",
      "4 Laci Simpanan",
      "Ukiran Daun Victoria",
      "Warna Emas & Perak",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/e6okobdb_3FE1FD47-B63D-4CFC-A7E9-777F70F4F698.png"
    ],
    category: "bilik-tidur"
  },
  {
    id: -12,
    name: "SET SOFA BALDU KELABU MEWAH 3+2+1+1 + MEJA KOPI UKIRAN",
    originalPrice: 2600,
    salePrice: 1300,
    discount: 50,
    bestSeller: true,
    topSelling: true,
    stock: 3,
    description: "Set sofa mewah gaya Eropah dengan baldu kelabu premium dan bingkai ukiran emas. Sesuai untuk ruang tamu yang elegant.",
    features: [
      "1x Sofa 3 Seater",
      "1x Sofa 2 Seater",
      "2x Single Seater",
      "1x Meja Kopi Ukiran Penuh",
      "Baldu Kelabu Premium",
      "Bingkai Ukiran Emas",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/70o0bnre_CA3304BE-AB9D-4C16-BCC9-927AF7D7CE80.png"
    ],
    category: "sofa"
  },
  {
    id: -11,
    name: "SET SOFA BALDU EMAS MEWAH 3+2+1+1 + MEJA KOPI - GAYA DIRAJA",
    originalPrice: 4000,
    salePrice: 2000,
    discount: 50,
    bestSeller: true,
    topSelling: true,
    limitedEdition: true,
    stock: 2,
    description: "Set sofa mewah gaya diraja dengan baldu emas dan ukiran bunga perak. Reka bentuk eksklusif untuk kediaman mewah.",
    features: [
      "1x Sofa 3 Seater",
      "1x Sofa 2 Seater",
      "2x Single Seater",
      "1x Meja Kopi Ukiran",
      "Baldu Emas Premium",
      "Ukiran Bunga Perak",
      "Gaya Diraja Eropah",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/5bb9g708_1A951A0C-D4B9-4458-88F1-441C3CB6A236.png"
    ],
    category: "sofa"
  },
  {
    id: -10,
    name: "SET SOFA JATI UKIRAN KLASIK 3+2+1 + MEJA KOPI",
    originalPrice: 2400,
    salePrice: 1199,
    discount: 50,
    bestSeller: true,
    stock: 5,
    description: "Set sofa jati solid dengan ukiran klasik Jepara. Kusyen putih lembut dan meja kopi berukir lengkap.",
    features: [
      "1x Sofa 3 Seater",
      "1x Sofa 2 Seater",
      "1x Single Seater",
      "1x Meja Kopi Ukiran",
      "Kayu Jati Solid Jepara",
      "Ukiran Klasik Halus",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/9t3tq9zp_D6450DAE-CE96-4638-8DF1-D2146209DD7B.png"
    ],
    category: "sofa"
  },
  {
    id: -9,
    name: "ALMARI KACA UKIRAN PUTIH EMAS - 4 PINTU DISPLAY",
    originalPrice: 2400,
    salePrice: 1200,
    discount: 50,
    limitedEdition: true,
    stock: 2,
    description: "Almari kaca mewah gaya Eropah dengan ukiran putih dan emas. Sesuai untuk display pinggan mangkuk atau hiasan.",
    features: [
      "4x Pintu Kaca Display",
      "4x Pintu Bawah Simpanan",
      "Design Tinggi & Grand",
      "Ukiran Full Klasik",
      "Warna Putih & Emas",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/s0n8ki0k_3B881FCB-9FB0-43F7-98A0-96CD0EDC16F6.png"
    ],
    category: "almari"
  },
  {
    id: -8,
    name: "ALMARI KACA JATI UKIRAN BUNGA EMAS - 4 PINTU",
    originalPrice: 2400,
    salePrice: 1200,
    discount: 50,
    limitedEdition: true,
    stock: 3,
    description: "Almari kaca jati solid dengan ukiran bunga emas. Reka bentuk melengkung klasik dengan ruang display dan simpanan.",
    features: [
      "4x Pintu Kaca Melengkung",
      "3x Laci Bawah",
      "Ruang Simpanan Besar",
      "Ukiran Bunga Emas",
      "Kayu Jati Solid",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/q2pneecz_C544CF7E-1EC7-4629-B250-B75C1170A419.png"
    ],
    category: "almari"
  },
  {
    id: -7,
    name: "SET SOFA JATI PREMIUM 3+2+1 + MEJA KOPI - KUSYEN CREAM",
    originalPrice: 2800,
    salePrice: 1400,
    discount: 50,
    bestSeller: true,
    topSelling: true,
    stock: 1,
    description: "Set sofa jati premium dengan kusyen cream lembut. Reka bentuk moden dan elegan sesuai untuk ruang tamu.",
    features: [
      "1x Sofa 3 Seater",
      "2x Single Chair",
      "1x Meja Kopi Jati",
      "Kusyen Cream Premium",
      "Kayu Jati Solid",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/uifvnvns_C433D9E5-CFCE-402F-ABF6-D3C314BA8545.png",
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/9mp85hre_29B17D86-AF8F-4193-BCEE-E5AA0FCF0694.png"
    ],
    category: "sofa"
  },
  {
    id: -6,
    name: "SET SOFA JATI UKIRAN BUNGA MERAH 3+2+1+1 - FREE KUSYEN BARU",
    originalPrice: 3000,
    salePrice: 1200,
    discount: 60,
    bestSeller: true,
    topSelling: true,
    stock: 10,
    description: "Set Sofa Jati dengan ukiran bunga halus dan kusyen corak merah. Set lengkap 3+2+1+1. FREE KUSYEN BARU!",
    features: [
      "FREE KUSYEN BARU",
      "Sofa 3 Seater",
      "Sofa 2 Seater",
      "Sofa 1 Seater",
      "Sofa 1 Seater",
      "Ukiran Bunga Halus",
      "Set Lengkap 3+2+1+1"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_edb92118-8a7b-4b9d-8dc3-38b5db744fd7/artifacts/7s7r8wi5_7F2DE797-7017-414A-9871-F5D09D05A670.png"
    ],
    category: "sofa"
  },
  {
    id: -5,
    name: "SET SOFA JATI UKIRAN BUNGA 3+2+1+1 - FREE KUSYEN BARU",
    originalPrice: 3000,
    salePrice: 1200,
    discount: 60,
    bestSeller: true,
    topSelling: true,
    stock: 10,
    description: "Set Sofa Jati dengan ukiran bunga halus. Set lengkap 3+2+1+1 dengan pilihan warna kusyen. FREE KUSYEN BARU!",
    features: [
      "FREE KUSYEN BARU",
      "Sofa 3 Seater",
      "Sofa 2 Seater",
      "Sofa 1 Seater",
      "Sofa 1 Seater",
      "Ukiran Bunga Halus",
      "Set Lengkap 3+2+1+1"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_edb92118-8a7b-4b9d-8dc3-38b5db744fd7/artifacts/xx2xnafc_BC8CF736-E890-4ED5-842A-7811D161E17E.png",
      "https://customer-assets.emergentagent.com/job_edb92118-8a7b-4b9d-8dc3-38b5db744fd7/artifacts/2uyo3upn_E954F6EA-F843-4D80-9971-78021B6A5AA0.png"
    ],
    category: "sofa"
  },
  {
    id: -2,
    name: "CLEARANCE RAYA - SET SOFA JATI UKIRAN + MEJA KOPI - FREE KUSYEN BARU",
    originalPrice: 1500,
    salePrice: 500,
    discount: 67,
    clearanceSale: true,
    stock: 5,
    description: "Set Sofa Jati dengan ukiran daun klasik dan meja kopi berukir. Kusyen corak hijau moden.",
    features: [
      "FREE KUSYEN BARU",
      "Sofa 3 Seater Ukiran",
      "Meja Kopi Berukir",
      "Kayu Jati Solid",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_edb92118-8a7b-4b9d-8dc3-38b5db744fd7/artifacts/tm35eww5_54245057-5729-4C70-90E1-2F697584AF9A.png"
    ],
    category: "sofa"
  },
  {
    id: 0,
    name: "SET SOFA JATI VERSACE 3+2+1+1 + MEJA KOPI KACA - FREE KUSYEN BARU",
    originalPrice: 2500,
    salePrice: 900,
    discount: 64,
    bestSeller: true,
    topSelling: true,
    stock: 5,
    description: "Set Sofa Jati Versace Full Set dengan kusyen baldu cream berkancing mewah. Ukiran Versace klasik pada rangka kayu jati solid. Set lengkap 3+2+1+1 + Meja kopi kaca tebal. FREE KUSYEN BARU!",
    features: [
      "FREE KUSYEN BARU",
      "Sofa 3 Seater",
      "Sofa 2 Seater",
      "Sofa 1 Seater x2",
      "Meja Kopi Kaca",
      "Set Lengkap 3+2+1+1"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_edb92118-8a7b-4b9d-8dc3-38b5db744fd7/artifacts/d0cfvc75_6A146610-36F2-4C5F-8C4A-75E4B3C1ED45.png"
    ],
    category: "sofa"
  },
  {
    id: 1,
    name: "SOFA EUROPE BELGIO BLACK P8",
    originalPrice: 10000,
    salePrice: 3000,
    discount: 70,
    bestSeller: true,
    promoItem: true,
    stock: 3,
    description: "Sofa Europe Belgio Black siap hantar depan rumah acik tau. Kali pertama yang membeli jati dari Gudang Boss Ijan akan menerima MEMBER KAD KEAHLIAN dengan potongan 10% untuk pembelian jati kali kedua. Kami juga ada penghantaran ke seluruh semenanjung Malaysia dan juga ke Singapore kecuali Sabah dan Sarawak.",
    features: [
      "Siap Hantar Depan Rumah",
      "MEMBER KAD KEAHLIAN - Potongan 10%",
      "Penghantaran Seluruh Semenanjung",
      "Penghantaran ke Singapore",
      "Kayu Jati Solid Premium",
      "Ukiran Emas Mewah"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/konn2myn_IMG_7952.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/r81p16f6_IMG_7955.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/o1j1phrt_IMG_7954.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/2416ur1x_IMG_7953.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/lpbdqf7s_IMG_7956.jpeg"
    ],
    category: "sofa"
  },
  {
    id: 2,
    name: "SET SOFA JATI PREMIUM",
    originalPrice: 9000,
    salePrice: 2500,
    discount: 72,
    bestSeller: true,
    stock: 7,
    description: "Set Sofa Jati Premium dengan ukiran klasik. Siap hantar ke seluruh Semenanjung Malaysia dan Singapore.",
    features: [
      "Kayu Jati Solid",
      "Ukiran Klasik Premium",
      "Siap Hantar Depan Rumah",
      "Penghantaran Seluruh Semenanjung"
    ],
    images: [
      "https://gudangbosijan.com/wp-content/uploads/2025/12/img_7466-scaled.jpeg"
    ],
    category: "sofa"
  },
  {
    id: 3,
    name: "SOFA SERBIA 3+2+1+1 + MEJA KOPI BESAR & KECIL",
    originalPrice: 9000,
    salePrice: 2500,
    discount: 72,
    bestSeller: true,
    stock: 4,
    description: "Sofa Serbia Full Set Production Boss Ijan dengan kusyen baldu premium warna maroon. Termasuk meja kopi besar dan kecil.",
    features: [
      "Sofa 3 Seater",
      "Sofa 2 Seater",
      "Sofa 1 Seater x 2",
      "Meja Kopi Besar 1",
      "Meja Kopi Kecil 1",
      "Production Kilang Boss Ijan",
      "Kusyen Baldu Premium"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/ok1istlo_IMG_7958.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/jk8oera1_IMG_7959.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/quv5ud9u_IMG_7960.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/177rf7bz_IMG_7961.jpeg"
    ],
    category: "sofa"
  },
  {
    id: 4,
    name: "SOFA ALADIN 3+2+1+1 + MEJA BESAR & MEJA KOPI",
    originalPrice: 5000,
    salePrice: 1800,
    discount: 64,
    bestSeller: true,
    stock: 6,
    description: "Sofa Aladin Full Set dengan kusyen baldu coklat premium. Termasuk meja besar dan meja kopi. Production Kilang Boss Ijan.",
    features: [
      "Sofa 3 Seater",
      "Sofa 2 Seater", 
      "Sofa 1 Seater x 2",
      "Meja Besar 1",
      "Meja Kopi 1",
      "Production Kilang Boss Ijan",
      "Kusyen Baldu Premium"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/uch35dvq_IMG_7968.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/y7jv22e1_IMG_7969.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/q7sfuv02_IMG_7970.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/dvvr9uon_IMG_7972.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/tv8heni5_IMG_7973.jpeg"
    ],
    category: "sofa"
  },
  {
    id: 5,
    name: "SOFA JATI FULL SET 3+2+1+1 + MEJA KOPI - BOLEH LOMPAT!",
    originalPrice: 5000,
    salePrice: 1500,
    discount: 70,
    bestSeller: true,
    promoItem: true,
    stock: 8,
    description: "Sofa Jati Full Set dengan kusyen salmon pink premium. Termasuk meja kopi besar dan kecil. Production Kilang Boss Ijan. BOLEH LOMPAT!",
    features: [
      "Sofa 3 Seater",
      "Sofa 2 Seater",
      "Sofa 1 Seater x 2",
      "Meja Kopi Besar 1",
      "Meja Kopi Kecil 1",
      "Production Kilang Boss Ijan",
      "BOLEH LOMPAT!"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/xlj6nn7x_IMG_7974.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/xrlbvjbo_IMG_7975.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/kz6ib80c_IMG_7976.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/zqbbcyfy_IMG_7977.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/g05rmvhk_IMG_7978.jpeg"
    ],
    category: "sofa"
  },
  {
    id: 6,
    name: "SOFA VIRGINA EXCLUSIVE CUSTOM - LIMITED EDITION",
    originalPrice: 8000,
    salePrice: 3000,
    discount: 63,
    bestSeller: true,
    limitedEdition: true,
    description: "Sofa Virgina Exclusive Custom dengan ukiran mewah dan kusyen cream premium. Limited Edition! Stok sangat terhad.",
    features: [
      "Sofa 3 Seater Mewah",
      "Sofa 2 Seater",
      "Sofa 1 Seater x 2",
      "Meja Set Lengkap",
      "Ukiran Kayu Premium",
      "LIMITED EDITION",
      "Kusyen Cream Premium"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/mhq7yqyb_IMG_7979.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/fm9ihjnu_IMG_7980.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/qfkkj9om_IMG_7981.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/l30d06pb_IMG_7982.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/rw8pzhas_IMG_7983.jpeg"
    ],
    category: "sofa"
  },
  {
    id: 7,
    name: "ALMARI SUDUT JATI - READY STOCK EDISI TERHAD",
    originalPrice: 2500,
    salePrice: 900,
    discount: 64,
    bestSeller: true,
    limitedEdition: true,
    description: "Almari Sudut Jati Ready Stock. Edisi Terhad! Sesuai untuk sudut ruang tamu atau bilik tidur.",
    features: [
      "Ready Stock",
      "Edisi Terhad",
      "Kayu Jati Solid",
      "Ukiran Klasik",
      "Sesuai Sudut Ruangan"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/i916we1d_IMG_7984.jpeg"
    ],
    category: "almari"
  },
  {
    id: 8,
    name: "SOFA SERENA JATI FULL SET - TOP JUALAN ONLINE & WALKIN",
    originalPrice: 3000,
    salePrice: 1000,
    discount: 67,
    bestSeller: true,
    topSelling: true,
    description: "Sofa Serena 3211 – Gred B. Rangka kayu jati dengan finishing kilat kemas, dipadankan baldu premium coklat lembut & elegan. Rekaan simple timeless, nampak mewah & sesuai untuk semua jenis ruang tamu.",
    features: [
      "TOP JUALAN ONLINE & WALKIN",
      "Finishing Gred B Kilang P6",
      "Sofa 3 Seater",
      "Sofa 2 Seater",
      "Sofa Single x 2",
      "Meja Kopi Besar",
      "Meja Kopi Kecil",
      "Baldu Premium Coklat"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/guwmpl35_IMG_7985.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/rjtx6zpq_IMG_7986.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/dx2mxqqs_IMG_7987.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/dwui8sjx_IMG_7988.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/pi94kz7f_IMG_7989.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/sgh1ak6i_IMG_8021.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/gju5nmz6_IMG_8020.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/5buqlpan_IMG_8022.jpeg"
    ],
    category: "sofa"
  },
  {
    id: 9,
    name: "SOFA DPR JATI FULL SET - MATERIAL BALDU P6",
    originalPrice: 2500,
    salePrice: 900,
    discount: 64,
    bestSeller: true,
    description: "Sofa DPR Jati Full Set – Finishing Kilat + Kusyen Baldu Coklat. Set sofa jati klasik dengan ukiran halus & kusyen baldu empuk. Lengkap 3+2+1+1 seater + meja kopi + side table. Kukuh, tahan lama & nampak mewah.",
    features: [
      "Finishing Kilat",
      "Kusyen Baldu Coklat",
      "Sofa 3+2+1+1 Seater",
      "Meja Kopi",
      "Side Table",
      "Ukiran Halus",
      "Kukuh & Tahan Lama"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/52zhsdu9_IMG_7990.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/8h9gv4kf_IMG_7991.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/x8ajshor_IMG_7992.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/6c5004hr_IMG_7993.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/2riomq7c_IMG_7994.jpeg"
    ],
    category: "sofa"
  },
  {
    id: 10,
    name: "SOFA ALLADIN JATI FULL SET - SYNTHETIC LEATHER BLACK",
    originalPrice: 3500,
    salePrice: 1200,
    discount: 66,
    bestSeller: true,
    description: "Sofa Alladin Jati Full Set dengan Synthetic Leather Black. Rekaan moden dan elegan dengan kulit sintetik hitam berkualiti tinggi.",
    features: [
      "Synthetic Leather Black",
      "Sofa 3+2+1+1 Seater",
      "Meja Set Lengkap",
      "Rekaan Moden",
      "Mudah Dijaga",
      "Tahan Lama"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/4zizeyjl_IMG_7995.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/hhaf0g12_IMG_7996.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/wq6z88kq_IMG_7997.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/5fv3l71o_IMG_7998.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/zr2rvwcg_IMG_7999.jpeg"
    ],
    category: "sofa"
  },
  {
    id: 11,
    name: "MEJA GENDONG JATI 6 KERUSI - FINISHING KILAT",
    originalPrice: 4000,
    salePrice: 1600,
    discount: 60,
    bestSeller: true,
    description: "Meja Gendong Jati dengan 6 Kerusi. Finishing Kilat premium untuk keluarga besar. Sesuai untuk ruang makan.",
    features: [
      "Meja Gendong Jati",
      "6 Kerusi",
      "Finishing Kilat",
      "Kayu Jati Solid",
      "Sesuai Keluarga Besar",
      "Ukiran Klasik"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/fe2t7l6p_IMG_8001.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/hkvyd1w7_IMG_8002.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/zhmtmg95_IMG_8003.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/7vszq00d_IMG_8004.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/yckz7ay7_IMG_8005.jpeg"
    ],
    category: "meja-makan"
  },
  {
    id: 12,
    name: "SET COMBO DAYBED KING MINIMALIST DIAMOND + KABINET TEPI",
    originalPrice: 3500,
    salePrice: 1400,
    discount: 60,
    bestSeller: true,
    description: "Set Combo Daybed King Minimalist Diamond dengan Kabinet Tepi. Ready Stock! Rekaan minimalis moden dengan ukiran diamond.",
    features: [
      "Daybed King Size",
      "Minimalist Diamond Design",
      "Kabinet Tepi",
      "Ready Stock",
      "Kayu Jati Solid",
      "Rekaan Moden"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/hbecrbkm_IMG_8013.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/tj3unsv7_IMG_8012.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/6uoxa6x2_IMG_8011.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/dxn55stl_IMG_8009.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/10dyacib_IMG_8007.jpeg"
    ],
    category: "daybed"
  },
  {
    id: 13,
    name: "SET COMBO KABINET TV + CERMIN DINDING JATI",
    originalPrice: 3000,
    salePrice: 1200,
    discount: 60,
    bestSeller: true,
    description: "Set Combo Kabinet TV + Cermin Dinding Jati. Kabinet TV jati kukuh + cermin dinding ukiran klasik handmade. Berat, tahan lama & terus jadikan ruang tamu nampak mewah.",
    features: [
      "Kabinet TV Jati",
      "Cermin Dinding Ukiran",
      "Handmade Klasik",
      "Berat & Kukuh",
      "Tahan Lama",
      "Nampak Mewah"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/422qy3p1_IMG_8017.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/pplf02e1_IMG_8018.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/5515ci45_IMG_8019.jpeg"
    ],
    category: "kabinet-tv"
  },
  {
    id: 14,
    name: "SOFA GANESA POLOS JATI FULL SET - SEMI TPK GRED A EKSPORT",
    originalPrice: 8000,
    salePrice: 3000,
    discount: 63,
    bestSeller: true,
    limitedEdition: true,
    description: "Sofa Ganesa Polos Jati Full Set. Semi TPK Kayu Jati Perhutani dengan Finishing Kilat Gred A Eksport. Set mewah ukiran klasik buatan tangan – kukuh, licin berkilau & tahan lama. Sesuai untuk ruang tamu eksklusif.",
    features: [
      "Semi TPK Kayu Jati Perhutani",
      "Finishing Kilat Gred A Eksport",
      "Sofa 3 Seater",
      "Sofa 2 Seater",
      "Sofa 1 Seater x 2",
      "Meja Kopi + Kaca",
      "Meja Sisi + Kaca x 2",
      "Ukiran Klasik Handmade"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/l7wyp4e7_IMG_1240.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/rrtnfv8h_IMG_1241.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/c2arfa1n_IMG_1242.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/5dje2x8s_IMG_1243.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/im1psdsz_IMG_1244.jpeg"
    ],
    category: "sofa"
  },
  {
    id: 15,
    name: "DAYBED QUEEN MINIMALIST - READY STOCK!",
    originalPrice: 2000,
    salePrice: 800,
    discount: 60,
    bestSeller: true,
    description: "Daybed Queen Minimalist Ready Stock! Kilang P6 Boss Ijan dengan Finishing Kilat dan Kayu Jati Solid.",
    features: [
      "Queen Size",
      "Minimalist Design",
      "Ready Stock",
      "Kilang P6 Boss Ijan",
      "Finishing Kilat",
      "Kayu Jati Solid"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/82om8iyi_IMG_1245.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/7fo3iis4_IMG_1246.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/v2304bim_IMG_1247.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/j8a4licw_IMG_1248.jpeg"
    ],
    category: "daybed"
  },
  {
    id: 16,
    name: "DAYBED KING SIZE MINIMALIST - FINISHING NC DOFF + KUSYEN",
    originalPrice: 3500,
    salePrice: 1200,
    discount: 66,
    bestSeller: true,
    description: "Daybed King Minimalist Semi TPK dengan Finishing NC DOF. Siap dengan kusyen premium. Kayu Jati berkualiti tinggi.",
    features: [
      "King Size",
      "Semi TPK Kayu Jati",
      "Finishing NC DOF",
      "Siap Kusyen Premium",
      "Minimalist Design",
      "Tahan Lama"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/ojhuz7e4_IMG_1249.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/je0r6z0j_IMG_1250.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/lst2xn2r_IMG_1251.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/6665l64t_IMG_1252.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/fdd9ac5a_IMG_1253.jpeg"
    ],
    category: "daybed"
  },
  {
    id: 17,
    name: "SET COBRA JATI FULL SET - FINISHING NATURAL EKSPORT",
    originalPrice: 4000,
    salePrice: 1500,
    discount: 63,
    bestSeller: true,
    description: "Set Cobra Jati Full Set dengan Finishing Natural Eksport. Material Kayu Jati Kampung dari Kilang P1 Boss Ijan.",
    features: [
      "Kayu Jati Kampung",
      "Finishing Natural Eksport",
      "Kilang P1 Boss Ijan",
      "Sofa 3+2+1+1 Seater",
      "Meja Set Lengkap",
      "Rekaan Cobra Klasik"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/lpmly1v8_IMG_1254.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/scaaohqz_IMG_1255.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/a2cdh03b_IMG_1256.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/ogwiu5cg_IMG_1257.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/tcujdvvr_IMG_1258.jpeg"
    ],
    category: "sofa"
  },
  {
    id: 18,
    name: "SOFA VIRGINA JATI FINISHING KILAT GRED A - CUSTOM ORDER",
    originalPrice: 8000,
    salePrice: 3000,
    discount: 63,
    bestSeller: true,
    limitedEdition: true,
    description: "Sofa Virgina Jati Full Set dengan Finishing Kilat Gred A. Set sofa jati kampung ukiran klasik dengan kemasan kilat gred A eksport. Rangka kukuh, ukiran halus kerja tangan, kusyen empuk & tahan lama. Lengkap dengan meja kopi dan meja sisi kaca tebal.",
    features: [
      "Finishing Kilat Gred A Eksport",
      "Custom Order Eksklusif",
      "Sofa 3+2+1+1 Seater",
      "Ukiran Halus Handmade",
      "Kusyen Empuk Premium",
      "Meja Kopi + Kaca Tebal",
      "Meja Sisi + Kaca Tebal"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/tgbtq3j8_IMG_1259.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/6oh8s36s_IMG_1260.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/5mfjpouk_IMG_1261.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/ztz7n8ob_IMG_1262.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/p5vwc4yu_IMG_1263.jpeg"
    ],
    category: "sofa"
  },
  {
    id: 19,
    name: "SOFA KERANG JATI FULL SET - EDISI MODERN STYLE EKSKLUSIF",
    originalPrice: 8000,
    salePrice: 3000,
    discount: 63,
    bestSeller: true,
    limitedEdition: true,
    description: "Sofa Kerang Jati Eksklusif. Sofa ukiran kerang klasik dari kayu jati gred premium, digabung dengan kemasan kusyen kulit berkancing kristal. Reka bentuk mewah, tahan lama & kukuh, sesuai untuk ruang tamu bergaya elegan.",
    features: [
      "Ukiran Kerang Klasik",
      "Kayu Jati Gred Premium",
      "Kusyen Kulit Berkancing Kristal",
      "Modern Style Eksklusif",
      "Reka Bentuk Mewah",
      "Tahan Lama & Kukuh"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/cw99d911_IMG_1264.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/6hgt47za_IMG_1265.jpeg",
      "https://customer-assets.emergentagent.com/job_ea9f8b57-324a-4429-acaa-865405742fa9/artifacts/xbkh0j2f_IMG_1266.jpeg"
    ],
    category: "sofa"
  },
  {
    id: 20,
    name: "SET MEJA MAKAN JATI 10 KERUSI - FINISHING KILAT GRED A",
    originalPrice: 5000,
    salePrice: 2000,
    discount: 60,
    bestSeller: true,
    topSelling: true,
    description: "Set Meja Makan Jati 10 Kerusi – Finishing Kilat Gred A. Meja jati padu berukir halus dengan kemasan kilat mewah. Lengkap 10 kerusi kusyen empuk, kukuh & tahan lama. Sesuai untuk ruang makan besar & majlis keluarga.",
    features: [
      "Meja Jati Padu Berukir Halus",
      "Finishing Kilat Gred A Mewah",
      "10 Kerusi Kusyen Empuk",
      "Kukuh & Tahan Lama",
      "Sesuai Ruang Makan Besar",
      "Sesuai Majlis Keluarga"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1ee00dce-b50f-48d4-be0c-9c54563ffba1/artifacts/28xd3g35_IMG_1269.jpeg",
      "https://customer-assets.emergentagent.com/job_1ee00dce-b50f-48d4-be0c-9c54563ffba1/artifacts/8xa8aqid_IMG_1270.jpeg",
      "https://customer-assets.emergentagent.com/job_1ee00dce-b50f-48d4-be0c-9c54563ffba1/artifacts/7g5qn14h_IMG_1271.jpeg",
      "https://customer-assets.emergentagent.com/job_1ee00dce-b50f-48d4-be0c-9c54563ffba1/artifacts/t3n6gvk3_IMG_1272.jpeg",
      "https://customer-assets.emergentagent.com/job_1ee00dce-b50f-48d4-be0c-9c54563ffba1/artifacts/ns1we8rk_IMG_1273.jpeg"
    ],
    category: "meja-makan"
  },
  {
    id: 21,
    name: "SOFA GANESA POLOS JATI FULL SET - SEMI TPK PERHUTANI FINISHING KILAT GRED A",
    originalPrice: 8000,
    salePrice: 3000,
    discount: 63,
    bestSeller: true,
    limitedEdition: true,
    description: "Sofa Ganesa Jati Full Set – Semi TPK Perhutani. Set eksport mewah dari Semi TPK Kayu Jati Perhutani, finishing kilat Gred A, ukiran klasik eksklusif. Full set 3+2+1+1 dengan meja kopi & meja sisi kaca tebal. Custom order 6–8 bulan untuk kualiti terbaik.",
    features: [
      "Semi TPK Kayu Jati Perhutani",
      "Finishing Kilat Gred A",
      "Ukiran Klasik Eksklusif",
      "Full Set 3+2+1+1",
      "Meja Kopi & Meja Sisi Kaca Tebal",
      "Custom Order 6-8 Bulan",
      "Kualiti Eksport Terbaik"
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1ee00dce-b50f-48d4-be0c-9c54563ffba1/artifacts/v8ebtp0w_IMG_1274.jpeg",
      "https://customer-assets.emergentagent.com/job_1ee00dce-b50f-48d4-be0c-9c54563ffba1/artifacts/2gejkst9_IMG_1275.jpeg",
      "https://customer-assets.emergentagent.com/job_1ee00dce-b50f-48d4-be0c-9c54563ffba1/artifacts/6loler9v_IMG_1276.jpeg",
      "https://customer-assets.emergentagent.com/job_1ee00dce-b50f-48d4-be0c-9c54563ffba1/artifacts/oa11415c_IMG_1277.jpeg",
      "https://customer-assets.emergentagent.com/job_1ee00dce-b50f-48d4-be0c-9c54563ffba1/artifacts/b7qnfhbm_IMG_1278.jpeg"
    ],
    category: "sofa"
  },
  {
    id: 100,
    name: "KATIL QUEEN UKIRAN PUTIH EMAS - GAYA KLASIK",
    originalPrice: 2400,
    salePrice: 1200,
    discount: 50,
    bestSeller: true,
    stock: 2,
    description: "Katil Queen Jati dengan ukiran putih dan emas klasik. Headboard ukiran bunga yang cantik. Sesuai untuk bilik tidur pengantin atau master bedroom.",
    features: [
      "Saiz Queen",
      "Ukiran Putih & Emas",
      "Headboard Ukiran Bunga",
      "Kayu Jati Solid",
      "Gaya Klasik Elegan",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/xkjig6i4_4144.jpg"
    ],
    category: "bilik-tidur"
  },
  {
    id: 101,
    name: "KATIL KING UKIRAN DIRAJA PINK VELVET - GAYA ISTANA",
    originalPrice: 3776,
    salePrice: 1888,
    discount: 50,
    bestSeller: true,
    limitedEdition: true,
    stock: 1,
    description: "Katil King Diraja dengan baldu pink velvet berkancing dan ukiran emas mewah. Mahkota ukiran bunga di headboard. Gaya istana yang sangat eksklusif untuk bilik tidur impian.",
    features: [
      "Saiz King",
      "Baldu Pink Velvet Berkancing",
      "Mahkota Ukiran Bunga Emas",
      "Ukiran Diraja Mewah",
      "Gaya Istana Eksklusif",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/14yjtaqj_4147.jpg"
    ],
    category: "bilik-tidur"
  },
  {
    id: 102,
    name: "KATIL KING UKIRAN JATI HITAM LEATHER - GAYA MEWAH",
    originalPrice: 3776,
    salePrice: 1888,
    discount: 50,
    bestSeller: true,
    limitedEdition: true,
    stock: 1,
    description: "Katil King Jati dengan kulit hitam berkancing dan ukiran emas mewah. Mahkota ukiran bunga di headboard. Kombinasi jati dan leather yang sangat elegan.",
    features: [
      "Saiz King",
      "Kulit Hitam Berkancing",
      "Mahkota Ukiran Bunga Emas",
      "Ukiran Jati & Emas",
      "Gaya Mewah Premium",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/tq9688b2_4146.jpg"
    ],
    category: "bilik-tidur"
  },
  {
    id: 103,
    name: "SET MEJA SANTAI KAYU PANGKERAI 8 KERUSI - EDISI OUTDOOR EKSPORT",
    originalPrice: 4600,
    salePrice: 2300,
    discount: 50,
    bestSeller: true,
    limitedEdition: true,
    stock: 2,
    description: "Set Meja Santai Outdoor dari kayu Pangkerai premium. 8 kerusi lipat dan meja oval besar. Sesuai untuk laman rumah, taman, atau balkoni. Edisi Eksport dengan kualiti antarabangsa.",
    features: [
      "Meja Oval Extensible",
      "8 Kerusi Lipat Premium",
      "Kayu Pangkerai Solid",
      "Tahan Cuaca Outdoor",
      "Edisi Eksport Quality",
      "Sesuai Taman & Laman",
      "Lainnya..."
    ],
    images: [
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/vrgxbxjn_4238.jpg",
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/bxedw9ex_4245.jpg",
      "https://customer-assets.emergentagent.com/job_1e502a16-9e5d-43c4-a483-0d982030e869/artifacts/oo24j1pe_4248.jpg"
    ],
    category: "meja-makan"
  }
];

// Kategori produk
export const categories = [
  { id: 'sofa', name: 'Sofa Jati', icon: '🛋️' },
  { id: 'meja', name: 'Meja Makan', icon: '🪑' },
  { id: 'katil', name: 'Katil Jati', icon: '🛏️' },
  { id: 'almari', name: 'Almari Jati', icon: '🗄️' },
  { id: 'daybed', name: 'Daybed', icon: '🛋️' },
  { id: 'bilik-tidur', name: 'Set Bilik Tidur', icon: '🏠' }
];

// Testimoni pelanggan - 50 ulasan
export const testimonials = [
  { id: 1, name: "Puan Zainab", age: "45 tahun", location: "Johor Bahru", image: "https://randomuser.me/api/portraits/women/1.jpg", text: "Kualiti memang tiptop! Anak-anak boleh lompat atas sofa pun tak rosak. Memang berbaloi sangat!" },
  { id: 2, name: "Encik Ahmad", age: "52 tahun", location: "Kuala Lumpur", image: "https://randomuser.me/api/portraits/men/2.jpg", text: "Dah 3 tahun guna set meja makan, masih cantik macam baru. Highly recommended!" },
  { id: 3, name: "Puan Fatimah", age: "38 tahun", location: "Melaka", image: "https://randomuser.me/api/portraits/women/3.jpg", text: "Staff sangat friendly dan helpful. Harga pun berpatutan untuk kualiti jati asli." },
  { id: 4, name: "Encik Razak", age: "48 tahun", location: "Selangor", image: "https://randomuser.me/api/portraits/men/4.jpg", text: "Beli untuk rumah baru, semua tetamu puji! Terima kasih Boss Ijan!" },
  { id: 5, name: "Puan Siti", age: "42 tahun", location: "Kedah", image: "https://randomuser.me/api/portraits/women/5.jpg", text: "Penghantaran cepat dan selamat. Packaging sangat rapi. 5 star!" },
  { id: 6, name: "Encik Hakim", age: "35 tahun", location: "Perak", image: "https://randomuser.me/api/portraits/men/6.jpg", text: "Ukiran sangat halus dan cantik. Memang craftmanship dari Jepara!" },
  { id: 7, name: "Puan Aishah", age: "55 tahun", location: "Terengganu", image: "https://randomuser.me/api/portraits/women/7.jpg", text: "Repeat customer ke-3 kali. Tak pernah mengecewakan!" },
  { id: 8, name: "Encik Ismail", age: "60 tahun", location: "Kelantan", image: "https://randomuser.me/api/portraits/men/8.jpg", text: "Beli untuk anak kahwin. Mereka sangat suka! Terima kasih." },
  { id: 9, name: "Puan Rohani", age: "47 tahun", location: "Pahang", image: "https://randomuser.me/api/portraits/women/9.jpg", text: "Harga gudang memang lebih murah dari kedai biasa. Jimat banyak!" },
  { id: 10, name: "Encik Kamal", age: "43 tahun", location: "Negeri Sembilan", image: "https://randomuser.me/api/portraits/men/10.jpg", text: "Service after sales pun bagus. Ada masalah terus settlekan." },
  { id: 11, name: "Puan Norma", age: "39 tahun", location: "Perlis", image: "https://randomuser.me/api/portraits/women/11.jpg", text: "Sanggup drive dari Perlis sebab nak tengok sendiri. Tak menyesal!" },
  { id: 12, name: "Encik Fauzi", age: "51 tahun", location: "Penang", image: "https://randomuser.me/api/portraits/men/12.jpg", text: "Set sofa sangat selesa dan tahan lama. Worth every ringgit!" },
  { id: 13, name: "Puan Mariam", age: "44 tahun", location: "Sabah", image: "https://randomuser.me/api/portraits/women/13.jpg", text: "Walaupun jauh di Sabah, delivery sampai dengan selamat. Terbaik!" },
  { id: 14, name: "Encik Azlan", age: "37 tahun", location: "Sarawak", image: "https://randomuser.me/api/portraits/men/14.jpg", text: "Perabot jati ni memang pelaburan jangka panjang. Sangat puas hati." },
  { id: 15, name: "Puan Habibah", age: "50 tahun", location: "Johor", image: "https://randomuser.me/api/portraits/women/15.jpg", text: "Beli untuk rumah kampung mak. Mak sangat gembira!" },
  { id: 16, name: "Encik Yusof", age: "46 tahun", location: "Selangor", image: "https://randomuser.me/api/portraits/men/16.jpg", text: "Staff sangat sabar layan semua pertanyaan. Service A+!" },
  { id: 17, name: "Puan Kalsom", age: "53 tahun", location: "Kuala Lumpur", image: "https://randomuser.me/api/portraits/women/17.jpg", text: "Finishing sangat cantik. Kilat dan licin. Memang premium!" },
  { id: 18, name: "Encik Rahman", age: "41 tahun", location: "Melaka", image: "https://randomuser.me/api/portraits/men/18.jpg", text: "Harga tak tipu. Apa yang quote, itu yang bayar. Honest seller!" },
  { id: 19, name: "Puan Suraya", age: "36 tahun", location: "Kedah", image: "https://randomuser.me/api/portraits/women/19.jpg", text: "Daybed sangat cantik! Jadi tempat lepak kegemaran keluarga." },
  { id: 20, name: "Encik Hafiz", age: "33 tahun", location: "Perak", image: "https://randomuser.me/api/portraits/men/20.jpg", text: "First time beli perabot jati, sangat impressed dengan kualiti!" },
  { id: 21, name: "Puan Diana", age: "40 tahun", location: "Terengganu", image: "https://randomuser.me/api/portraits/women/21.jpg", text: "Set meja makan dengan 10 kerusi, perfect untuk family gathering!" },
  { id: 22, name: "Encik Nasir", age: "58 tahun", location: "Kelantan", image: "https://randomuser.me/api/portraits/men/22.jpg", text: "Dah beli 5 set untuk semua anak. Semua puas hati!" },
  { id: 23, name: "Puan Aminah", age: "49 tahun", location: "Pahang", image: "https://randomuser.me/api/portraits/women/23.jpg", text: "Almari jati ni sangat kukuh dan berat. Memang solid!" },
  { id: 24, name: "Encik Rizal", age: "34 tahun", location: "N. Sembilan", image: "https://randomuser.me/api/portraits/men/24.jpg", text: "Custom order ikut size rumah. Boss Ijan boleh accommodate!" },
  { id: 25, name: "Puan Nadia", age: "31 tahun", location: "Perlis", image: "https://randomuser.me/api/portraits/women/25.jpg", text: "Beli untuk hantaran kahwin. Mertua sangat impressed!" },
  { id: 26, name: "Encik Farid", age: "45 tahun", location: "Penang", image: "https://randomuser.me/api/portraits/men/26.jpg", text: "Boleh bayar deposit dulu, balance bila hantar. Sangat flexible!" },
  { id: 27, name: "Puan Liyana", age: "29 tahun", location: "Johor", image: "https://randomuser.me/api/portraits/women/27.jpg", text: "Design klasik tapi tetap nampak moden. Love it!" },
  { id: 28, name: "Encik Zahid", age: "54 tahun", location: "Selangor", image: "https://randomuser.me/api/portraits/men/28.jpg", text: "Perabot warisan untuk generasi akan datang. Berbaloi!" },
  { id: 29, name: "Puan Izzah", age: "43 tahun", location: "KL", image: "https://randomuser.me/api/portraits/women/29.jpg", text: "Showroom sangat besar dengan banyak pilihan. Highly recommend!" },
  { id: 30, name: "Encik Imran", age: "39 tahun", location: "Melaka", image: "https://randomuser.me/api/portraits/men/30.jpg", text: "Boss Ijan sendiri sangat ramah dan helpful. Great experience!" },
  { id: 31, name: "Puan Ramlah", age: "56 tahun", location: "Kedah", image: "https://randomuser.me/api/portraits/women/31.jpg", text: "Repeat order untuk rumah baru. Tak nak tukar kedai lain dah!" },
  { id: 32, name: "Encik Syafiq", age: "30 tahun", location: "Perak", image: "https://randomuser.me/api/portraits/men/32.jpg", text: "Budget-friendly tapi kualiti premium. Sangat berbaloi!" },
  { id: 33, name: "Puan Nurul", age: "35 tahun", location: "Terengganu", image: "https://randomuser.me/api/portraits/women/33.jpg", text: "Kusyen sangat selesa dan cantik. Perfect match dengan sofa!" },
  { id: 34, name: "Encik Halim", age: "47 tahun", location: "Kelantan", image: "https://randomuser.me/api/portraits/men/34.jpg", text: "Install team sangat profesional. Siap setup semua dengan kemas." },
  { id: 35, name: "Puan Salina", age: "41 tahun", location: "Pahang", image: "https://randomuser.me/api/portraits/women/35.jpg", text: "Meja kopi dengan kaca sangat cantik. Jadi focal point rumah!" },
  { id: 36, name: "Encik Azmi", age: "52 tahun", location: "N. Sembilan", image: "https://randomuser.me/api/portraits/men/36.jpg", text: "Selepas 5 tahun, perabot masih nampak baru. Kualiti terbaik!" },
  { id: 37, name: "Puan Mazni", age: "38 tahun", location: "Perlis", image: "https://randomuser.me/api/portraits/women/37.jpg", text: "Beli set lengkap untuk ruang tamu. Transformasi total!" },
  { id: 38, name: "Encik Rashid", age: "44 tahun", location: "Penang", image: "https://randomuser.me/api/portraits/men/38.jpg", text: "Comparison dengan kedai lain, Boss Ijan jauh lebih berbaloi!" },
  { id: 39, name: "Puan Hidayah", age: "32 tahun", location: "Johor", image: "https://randomuser.me/api/portraits/women/39.jpg", text: "Reply WhatsApp sangat cepat. Service sangat responsive!" },
  { id: 40, name: "Encik Amir", age: "36 tahun", location: "Selangor", image: "https://randomuser.me/api/portraits/men/40.jpg", text: "Ukiran bunga sangat detail. Memang handcrafted dengan teliti!" },
  { id: 41, name: "Puan Zarina", age: "48 tahun", location: "KL", image: "https://randomuser.me/api/portraits/women/41.jpg", text: "Cermin dinding ukiran jadi statement piece rumah saya!" },
  { id: 42, name: "Encik Fahmi", age: "40 tahun", location: "Melaka", image: "https://randomuser.me/api/portraits/men/42.jpg", text: "Kabinet TV sangat kukuh dan spacious. Perfect untuk family!" },
  { id: 43, name: "Puan Hana", age: "33 tahun", location: "Kedah", image: "https://randomuser.me/api/portraits/women/43.jpg", text: "Beli untuk rumah sewa holiday. Semua guest puji perabot!" },
  { id: 44, name: "Encik Zainal", age: "55 tahun", location: "Perak", image: "https://randomuser.me/api/portraits/men/44.jpg", text: "Member card dapat 10% discount untuk next purchase. Best!" },
  { id: 45, name: "Puan Fauziah", age: "46 tahun", location: "Terengganu", image: "https://randomuser.me/api/portraits/women/45.jpg", text: "Set bilik tidur lengkap sangat cantik. Macam hotel 5 star!" },
  { id: 46, name: "Encik Hamid", age: "59 tahun", location: "Kelantan", image: "https://randomuser.me/api/portraits/men/46.jpg", text: "Pelaburan terbaik untuk rumah. Jati ni tahan sampai bila-bila!" },
  { id: 47, name: "Puan Laila", age: "37 tahun", location: "Pahang", image: "https://randomuser.me/api/portraits/women/47.jpg", text: "Photos tak tipu, apa yang lihat online, itu yang dapat!" },
  { id: 48, name: "Encik Nazri", age: "42 tahun", location: "N. Sembilan", image: "https://randomuser.me/api/portraits/men/48.jpg", text: "Boleh request finishing ikut warna yang nak. Very flexible!" },
  { id: 49, name: "Puan Rashidah", age: "51 tahun", location: "Perlis", image: "https://randomuser.me/api/portraits/women/49.jpg", text: "Jiran datang tengok terus minta contact Boss Ijan. Haha!" },
  { id: 50, name: "Encik Lokman", age: "49 tahun", location: "Penang", image: "https://randomuser.me/api/portraits/men/50.jpg", text: "Terbaik! Dah recommend kepada semua kawan dan family. 10/10!" }
];
